import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const ssrCacheSiteConfig: SiteConfigFn<{}> = () => {
	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {},
	}
}

const name = 'ssrCache'

export const config = { site: ssrCacheSiteConfig, name }
